'use client';

import { c as _c } from "react/compiler-runtime";
import './gifts-total.scss';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { useCart } from '@sola/cart-sdk/store.tsx';
import { isItemGift } from '@sola/shared-utils/cart/cart-item-type-guards.ts';
type GiftsTotalProps = {
  totalGiftAmount?: number;
};
export const GiftsTotal: React.ComponentType<GiftsTotalProps> = t0 => {
  const $ = _c(44);
  const {
    totalGiftAmount: totalGiftAmountProp
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["my", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const {
    actions: t2,
    isReady,
    cart
  } = useCart("actions", "isReady", "cart");
  const {
    getCart,
    goToCheckout
  } = t2;
  let t3;
  let t4;
  if ($[1] !== getCart || $[2] !== isReady) {
    t3 = () => {
      if (!isReady) {
        getCart();
      }
    };
    t4 = [getCart, isReady];
    $[1] = getCart;
    $[2] = isReady;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let isCheckoutDisabled;
  let t10;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] !== cart?.items || $[6] !== t || $[7] !== totalGiftAmountProp) {
    const total = (cart?.items ?? []).filter(isItemGift).reduce(_temp, 0);
    const totalGiftAmount = totalGiftAmountProp ?? total;
    isCheckoutDisabled = totalGiftAmount <= 0;
    t10 = "GiftsTotal";
    t9 = "flex items-center justify-between gap-snug-lg";
    t7 = "";
    let t11;
    if ($[15] !== t) {
      t11 = t("my:giftsTotal.totalGift", "Total Gift");
      $[15] = t;
      $[16] = t11;
    } else {
      t11 = $[16];
    }
    if ($[17] !== t11) {
      t8 = <p className="GiftsTotal__label label-lg label-neutral-mild label-potent mb-snug-lg">{t11}</p>;
      $[17] = t11;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    t5 = "GiftsTotal__amount m-none heading-sm";
    t6 = t("core:numbers.currencyCustom", {
      amount: totalGiftAmount
    });
    $[5] = cart?.items;
    $[6] = t;
    $[7] = totalGiftAmountProp;
    $[8] = isCheckoutDisabled;
    $[9] = t10;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    isCheckoutDisabled = $[8];
    t10 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  let t11;
  if ($[19] !== t5 || $[20] !== t6) {
    t11 = <p className={t5}>{t6}</p>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t7 || $[24] !== t8) {
    t12 = <div className={t7}>{t8}{t11}</div>;
    $[22] = t11;
    $[23] = t7;
    $[24] = t8;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== goToCheckout) {
    t13 = () => {
      goToCheckout();
    };
    $[26] = goToCheckout;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t) {
    t14 = t("my:giftsTotal.reviewAndCheckout", "Review & Checkout");
    $[28] = t;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== isCheckoutDisabled || $[31] !== t13 || $[32] !== t14) {
    t15 = <button type="button" disabled={isCheckoutDisabled} onClick={t13}>{t14}</button>;
    $[30] = isCheckoutDisabled;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== isCheckoutDisabled || $[35] !== t15) {
    t16 = <ButtonStyle variant="primary" size="lg" disabled={isCheckoutDisabled}>{t15}</ButtonStyle>;
    $[34] = isCheckoutDisabled;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t12 || $[38] !== t16 || $[39] !== t9) {
    t17 = <div className={t9}>{t12}{t16}</div>;
    $[37] = t12;
    $[38] = t16;
    $[39] = t9;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t10 || $[42] !== t17) {
    t18 = <div className={t10}>{t17}</div>;
    $[41] = t10;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
};
function _temp(sum, item) {
  return sum + item.amount;
}